import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { searchProviders } from "../../actions/yodlee";
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? {} : _ref$payload,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? {} : _ref$meta;

  switch (type) {
    case searchProviders.SUCCESS_TYPE:
      {
        var query = meta.query; // provider should be a list of providers

        var provider = payload.provider;
        var results = Array.isArray(provider) ? provider : [];
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, query, results));
      }

    default:
      return state;
  }
});